import { appKey } from 'config';

export const getKeyById = id => id ? `${appKey}t172r${id}` : null;
